import React, { useState, useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "@material-ui/core";

import { RouteComponentProps } from "react-router-dom";
import Loader from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import * as api from "../../api";
import classes from "../UploadMedia/spinner.module.scss";
import { imgData } from "../UploadMedia/StaticIconName";
import { useDeviceSelectors } from "react-device-detect";
interface ViewMediaProps extends RouteComponentProps<any> {}
const MpegAlertUserAgents = process.env.REACT_APP_MpegAlertSupportedBrowser;

const ViewMedia: React.FC<ViewMediaProps> = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
 const [mediaFile, setMediaFile] = useState<{}[]>([]);
  const [isOverlay, setIsOverlay] = useState("none");
  const [getWorkOrderId, setWorkOrderId] = useState<any>();
  const [base64Data, setBase64Data] = useState("");
  const [contentType, setContentType] = useState([]);
  const [isProccessing, setIsProccessing] = useState(false);
  const [isError, setIsError] = useState("");
  const [selectedId, setSelectedId] = useState();
  const videoRef: any = useRef();
  const location = useLocation();
  let inAppContent: boolean = false;
  const [isMpegSupportedBrowser, setMpegSupportedBrowser]: any =
    useState(false);

  useEffect(() => {
    
    if (isError) {
      setIsOverlay("none");
    }
  }, [isError]);
  const customerID = useSelector((state: any) => state.addresses?.customerid);
  const detectedDeviceBrowser = useDeviceSelectors(window.navigator.userAgent);

  useEffect(() => {
    for (let [key, value] of Object.entries(detectedDeviceBrowser[0])) {
      if (key === MpegAlertUserAgents) {
        setMpegSupportedBrowser(value);
      }
    }
  }, []);

  const fetchMediaData = async (id: any) => {
    setIsLoading(true);
    try {
      const response = await api.getMediaData(id);
      setMediaFile(response.documents);
    } catch (e: any) {
      setIsError("View_Media_Error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setWorkOrderId(location?.state);
    fetchMediaData(location?.state);
  }, [location]);

  const backButtonHandler = () => {
    props.history.push({
      pathname: "/historicRepairs",
      state: { viewMediaID: location.state },
    });
  };

  /* Displaying overlay on media click */
  const displayViewMediaDetails = async (mediaId: any, content: any) => {
    setIsError("");
    setIsProccessing(true);
    setIsOverlay("block");
    setContentType(content.split("/"));
    setSelectedId(mediaId);

    try {
      const response = await api.getViewMediaDetail(getWorkOrderId, mediaId);
      const data1 = response.media.replace('"', "");

      let selectedMedia = `data:${content};base64,${data1}`;

      setBase64Data(selectedMedia);

      setIsProccessing(false);

      // istanbul ignore next Displaying pdf alert and closing overlay
      if (content.split("/")[1] === "pdf") {
        setIsOverlay("none");
        const byteCharacters = atob(data1);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: content });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");
      }
    } catch (e: any) {
      setIsProccessing(false);
      setIsError("View_Media_Error");
    }
  };

  const closeOverLay = () => {
    setIsOverlay("none");
    if (contentType[1] !== "mpeg" && contentType[0] === "video") {
      videoRef?.current?.pause();
    }
  };

  const displayErrorMessage = useCallback(() => {
    return (
      mediaFile.length === 0 &&
      isError && (
        <div className="error pdf-alert mt-2 mb-2" data-testid="apierror">
          <div className="w-full px-4 py-2 bg-yellow flex items-center">
            <div className="px-4 pr-8">
              <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
            </div>
            <div className="flex items-center text-black">
              <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                {t(isError)}
              </p>
            </div>
          </div>
        </div>
      )
    );
  }, [isError]);

  return (
    <Container id="supp-main-container" role="main">
      {isLoading ? (
        <Loader type="ThreeDots" color="#00BFFF" height={50} width={50} />
      ) : (
        <>
          <div className="title">
            <h1>{t("View Media")}</h1>
          </div>
          <hr />
          <div className="content" data-testid="media">
            <ul>
              {mediaFile?.map((data: any) => {
                data?.metadata?.map((res: any) => {
                  inAppContent = false;
                  if(res.key === "IsMediaAppropriate" && res.value === "false") {
                    inAppContent = true;
                  }
                });
                return data?.metadata?.map((res: any) => {
                    if(res.key === "content-type" && inAppContent === false) {
                    const matchData = res.value.split("/");
                    return imgData.map((item: any, index: number) => {
                      if (
                        matchData[1] === item.id ||
                        matchData[1] === item.id.toUpperCase()
                      ) {
                        return (
                          <>
                            <li
                              data-testid={`detailsImg${item.id}`}
                              key={index}
                              className="imgClass mb-2"
                              onClick={() =>
                                displayViewMediaDetails(data.id, res.value)
                              }
                            >
                              <img
                                src={item.src}
                                alt={`thumbnail icon${Math.floor(
                                  Math.random() * 20
                                )}`}
                              />
                              <span className="imgName">
                                {data.media.fileName}
                              </span>
                            </li>
                            {isError && selectedId === data.id && (
                              <div className="error pdf-alert mt-2 mb-2">
                                <div className="w-full px-4 py-2 bg-yellow flex items-center">
                                  <div className="px-4 pr-8">
                                    <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
                                  </div>
                                  <div className="flex items-center text-black">
                                    <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                                      {t(isError)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        );
                      }
                    });
                  }
                  else if(inAppContent ===true && res.key === "IsMediaAppropriate" && res.value === "false") {
                    return (
                      <div className="pl-4 pt-2 pb-2">{t("MediaRemovedMsg")}</div>
                    )
                  }
                })
              })}
            </ul>
            {displayErrorMessage()}
          </div>
        </>
      )}

      <div className="overlay" style={{ display: isOverlay }}>
        {isProccessing ? (
          <div id="UploadingOverlay">
            <div className={classes.overlayContainer}>
              <div className={classes.overlayContent}>
                <div className={classes.spinner}></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="mediaViewOverlay">
            <span
              className="deleteIcon"
              onClick={closeOverLay}
              data-testid="overlay"
            >
              X
            </span>
            <div className="mediaView">
              {contentType[0] === "video" && contentType[1] !== "mpeg" && (
                <video
                  controls
                  autoPlay
                  className="enlargeImgView"
                  ref={videoRef}
                >
                  <source src={base64Data} type="video/mp4"></source>
                </video>
              )}

              {!isMpegSupportedBrowser &&
                contentType[0] === "video" &&
                contentType[1] === "mpeg" && (
                  <>
                    <video
                      controls
                      autoPlay
                      className="enlargeImgView"
                      // style={{ backgroundColor: "#333333", height: "99%" }}
                    >
                      <source src={base64Data} type="video/mp4"></source>
                    </video>
                    <div className="error overlayMpeg">
                      <div className="w-full px-4 py-2 bg-yellow flex items-center">
                        <div className="px-1 pr-8">
                          <i className="fas fa-exclamation-triangle text-brick-70 w-8 h-6"></i>
                        </div>
                        <div className="flex items-center text-black">
                          <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                            Your browser doesn't support playing MPEG videos,
                            please click{" "}
                            <a download="video.mpeg" href={base64Data}>
                              here
                            </a>{" "}
                            to download the video instead.
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              {contentType[0] === "video" &&
                contentType[1] === "mpeg" &&
                isMpegSupportedBrowser && (
                  <>
                    <video
                      controls
                      autoPlay
                      className="enlargeImgView"
                      style={{ backgroundColor: "#333333", height: "99%" }}
                    >
                      <source src={base64Data} type="video/mp4"></source>
                    </video>
                    <div className="error overlayMpeg">
                      <div className="w-full px-4 py-2 bg-yellow flex items-center">
                        <div className="px-1 pr-8">
                          <i className="fas fa-exclamation-triangle text-brick-70 w-8 h-6"></i>
                        </div>
                        <div className="flex items-center text-black">
                          <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                            {t("Media_MPEG_Apple")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              {contentType[0] === "image" && (
                <img
                  src={base64Data}
                  alt={`thumbnail icon${Math.floor(Math.random() * 20)}`}
                  className="enlargeImgView"
                />
              )}
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default ViewMedia;
